import { SIGNALING_STATUS } from "../../constants/signaling";
import { SignalingRingingResponse } from "../../proto/SignalingRinging_pb";
import store from "../../store";
import { setSignalingStatus } from "../../store/signaling/actions";
import BaseHandler from "../BaseHandler";

export default class HandleSignalingRingingResponse extends BaseHandler<SignalingRingingResponse> {
  handle() {
    const signalingRingingResponse = this.response.toObject();
    if (signalingRingingResponse.response?.id !== "") {
      store.dispatch(setSignalingStatus(SIGNALING_STATUS.RINGING));
    }
  }
}
